'use strict';

import angular from 'angular';

export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('budget-general', {
        url: '/budget-general?jeuDonnees&typeDonnees&annee',
        templateUrl: 'app/budget-general/budget-general.html',
        controller: 'BudgetGeneralController'
      });
  }]);
